import { styled, Box } from '@mui/material';

export const TasksList = styled(Box)({
  display   : 'flex',
  gap       : '16px',
  flexWrap  : 'wrap',
  marginTop : '44px',
});

export const Row = styled(Box)({
  display        : 'flex',
  justifyContent : 'space-between',
  alignItems     : 'center',
});

export const Breadcrumb = styled(Box)({
  display    : 'flex',
  alignItems : 'center',
  gap        : '10px',

  a : {
    textDecoration : 'none',
  },
  marginTop    : '28px',
  marginBottom : '10px',
});
